import { ErrorResponse, JobCompletedEnum, OperationTypeEnum, ShiftsEnum } from '@gtpl/shared-models/common-models';
import { CommonResponse, LotDetailsDto, LotDetailsResModel, RejectionDto, RejectionResponseModel, RejectionsDto, RejectionsResponseModel } from '@gtpl/shared-models/production-management';
import { PlantRequest } from '@gtpl/shared-models/raw-material-procurement';
import { QaQcOperationsService, QcDefectService, WorkstationService } from '@gtpl/shared-services/production';
import { saleOrder, SaleOrderService } from '@gtpl/shared-services/sale-management';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import { GenericTransactionManager } from 'apps/services/backend/typeorm-transactions/generic-transaction-manager';
import appSettings from 'apps/services/config';
import { MoreThan, createQueryBuilder, getManager } from 'typeorm';
import { ProductionInventory } from '../operations-track/entities/production-inventory.entity';
import { ProductionLog } from '../operations-track/entities/production-log.entity';
import { ProductionInventoryRepository } from '../operations-track/repositories/production-inventory.repository';
import { ProductionLogRepository } from '../operations-track/repositories/production-log.repository';
import { WorkStations } from '../workstations/workstations.entity';
import { AssignRejectionRepository } from './assign-rejection.repository';
import { AssignRejections } from './assign-rejections.entity';
import { RejectionDataDto } from './dto/rejection-data.dto';
import { RejectionRequest } from './dto/rejection-detail -id-request';
import { RejectionsRepository } from './rejection.repository';
import { Rejections } from './rejections.entity';

@Injectable()
export class RejectionsService {
    constructor(
        @InjectRepository(RejectionsRepository) private rejectionRepository: RejectionsRepository,
        @InjectRepository(ProductionInventoryRepository) private prodInvRepository: ProductionInventoryRepository,
        @InjectRepository(ProductionLogRepository) private logRepository: ProductionLogRepository, private saleOrderService: SaleOrderService, private qaQcService: QaQcOperationsService, private workStationService:WorkstationService,
        private defectservice:QcDefectService
    ) { }

    async createRejectionAssignment(inputReq: RejectionsDto): Promise<RejectionsResponseModel> {
        console.log(inputReq);
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const prodInv = new ProductionInventory();
            prodInv.lotNumber = inputReq.lotNumber;
            prodInv.createdUser = inputReq.createdUser;
            prodInv.subLotNumber = inputReq.subLotNumber;
            prodInv.saleOrderId = inputReq.saleOrderId;
            prodInv.saleOrderItemId = inputReq.saleOrderItemId;
            prodInv.operation = (inputReq.operation==OperationTypeEnum.BE_HEADING)?OperationTypeEnum.GRN:inputReq.operation;
            prodInv.nextOperation = inputReq.nextOperation;
            prodInv.physicalQuantity = inputReq.physicalQuantity;
            prodInv.wipQuantity = 0;
            prodInv.inputGrade = inputReq.inputGrade;
            prodInv.boxes = inputReq.boxes;
            prodInv.plantId = inputReq.plantId;
            if (inputReq.subPlantId) {
                prodInv.subPlantId = inputReq.subPlantId;
            }
            const prodInvResponse = await manager.getCustomRepository(ProductionInventoryRepository).save(prodInv);
            console.log('prodInvResponse' + prodInvResponse.productionInventoryId);
            if (prodInvResponse) {
                const productionLogObj = new ProductionLog();
                productionLogObj.lotNumber = inputReq.lotNumber;
                productionLogObj.subLotNumber = inputReq.subLotNumber;
                productionLogObj.saleOrderId = inputReq.saleOrderId;
                productionLogObj.saleOrderItemId = inputReq.saleOrderItemId;
                productionLogObj.operationType = (inputReq.operation==OperationTypeEnum.BE_HEADING)?OperationTypeEnum.GRN:inputReq.nextOperation;
                // job number generation 
                const today = new Date();
                const CurrentYear = today.getFullYear();
                const CurrentMonth = today.getMonth();
                let fromDate = 0;
                let toDate = 0;
                let totalRecords = await (await this.logRepository.find({ where: { operationType: inputReq.nextOperation } })).length;
                if (CurrentMonth < 4) {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                } else {
                    fromDate = (CurrentYear);
                    toDate = (CurrentYear + 1);
                }

                totalRecords = totalRecords + 1;

                let refNo = totalRecords + "";
                while (refNo.length < 4) refNo = "0" + refNo;

                const soakingJobNo = inputReq.operation + "/" + (fromDate.toString().substr(-2)) + "-" + (toDate.toString().substr(-2)) + "/" + refNo;

                productionLogObj.jobNumber = soakingJobNo;//need to write auto generate logic
                productionLogObj.plantId = inputReq.plantId;
                if (inputReq.subPlantId) {
                    productionLogObj.subPlantId = inputReq.subPlantId;
                }
                // productionLogObj.workStationType = inputReq.workStationType;
                productionLogObj.workstation = new WorkStations();
                productionLogObj.workstation.workstationId = inputReq.workstation;
                productionLogObj.jobStatus = JobCompletedEnum.NO;
                productionLogObj.inputGrade = inputReq.inputGrade;
                productionLogObj.inputQuantity = inputReq.physicalQuantity;
                productionLogObj.plannedGrade = 0;
                productionLogObj.assignedTime = inputReq.assignedTime;
                productionLogObj.assignedUser = inputReq.createdUser;//need to get assigned user
                productionLogObj.shift = ShiftsEnum.General;
                productionLogObj.createdUser = inputReq.createdUser;
                productionLogObj.prodInvId = prodInvResponse.productionInventoryId;
                const saveProdLog = await manager.getCustomRepository(ProductionLogRepository).save(productionLogObj);
                const rejectionsObj = new AssignRejections();
                rejectionsObj.rejectedQuantity = inputReq.physicalQuantity;
                rejectionsObj.assignedQuantity = inputReq.physicalQuantity;
                rejectionsObj.lotNumber = inputReq.lotNumber;
                rejectionsObj.saleOrderId = inputReq.saleOrderId;
                rejectionsObj.operation = inputReq.operation;
                rejectionsObj.saleOrderItemId = inputReq.saleOrderItemId;
                rejectionsObj.unitId = inputReq.plantId;
                rejectionsObj.assignedTime = inputReq.assignedTime;
                rejectionsObj.Count = inputReq.boxes;//need to get assigned user
                rejectionsObj.createdAt = inputReq.assignedTime;
                rejectionsObj.createdUser = inputReq.createdUser;
                rejectionsObj.prodInvId = prodInvResponse.productionInventoryId;
                await manager.getCustomRepository(AssignRejectionRepository).save(rejectionsObj);
                const updateAssignRejectedQty = await manager.getCustomRepository(ProductionInventoryRepository).updateInventoryAssignRejectedQuantity(inputReq.lotNumber, inputReq.subLotNumber, inputReq.productionInventoryId, inputReq.physicalQuantity);
                if (saveProdLog && updateAssignRejectedQty) {
                    manager.completeTransaction();
                    return new RejectionsResponseModel(true, 1001, 'Rejection Qty Assigned to SO. ')
                } else {
                    return new RejectionsResponseModel(false, 9999, 'some thing went wrong')
                }
            }

        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }


    /**
     * create rejection record and updated production inventory rejection quantity
     * @param inputReq 
     * @returns 
     */
    async createRejection(inputReq: RejectionDataDto): Promise<CommonResponse> {
        const manager = new GenericTransactionManager();
        try {
            await manager.startTransaction();
            const entity = new Rejections();
            entity.plantId = inputReq.plantId;
            entity.shift = inputReq.shift;
            entity.lotNumber = inputReq.lotNumber;
            entity.subLotNumber=inputReq.subLotNumber;
            entity.saleOrderId = inputReq.saleOrderId;
            entity.saleOrderItemId = inputReq.saleOrderItemId;
            entity.count = inputReq.count;
            entity.operation = inputReq.operation;
            entity.workstation = inputReq.workstation;
            entity.testId = inputReq.qaQcTestId;
            entity.samples = inputReq.noOfSamples;
            entity.quantity = inputReq.quantityTested;
            entity.rejectionQuantity = inputReq.rejectedQuantity;
            entity.rejectionReason = inputReq.rejectionReason;
            entity.testResult = inputReq.testResult;
            entity.remarks = inputReq.remarks;
            await manager.getCustomRepository(RejectionsRepository).save(entity);
            await manager.getCustomRepository(ProductionInventoryRepository).update({ lotNumber: inputReq.lotNumber, saleOrderId: inputReq.saleOrderId, saleOrderItemId: inputReq.saleOrderItemId, operation: inputReq.operation, plantId: inputReq.plantId }, { rejectedQuantity: () => `rejected_quantity+${inputReq.rejectedQuantity}` });
            manager.completeTransaction();
            return new CommonResponse(true, 10000, 'Rejection Reported Successfully');
        } catch (error) {
            await manager.releaseTransaction();
            throw error;
        }
    }
    async getAllLotDetailsInfo(req: PlantRequest): Promise<LotDetailsResModel> {
        const manager = getManager();

        try {
            const query=`select sd.po_number as poNumber,rejection_id as rejectionId,rejections.lot_number as lotNumber,rejections.plant_id as plantId,rejections.sale_order_id as saleOrderId,rejections.rejection_quantity as rejectionQuantity,rejections.quantity as quantityTested ,rejections.test_id as testId ,rejections.samples as noOfSamples,rejections.rejection_reason as rejectionReason,rejections.test_result as testResult,rejections.sale_order_item_id as saleOrderItemId,qa_qc_operations.test_name as testName from `+appSettings.production_db+`.rejections rejections left join `+appSettings.production_db+`.qa_qc_operations qa_qc_operations on qa_qc_operations.qa_qc_op_id = rejections.test_id left join `+appSettings.sales_db+`.so_invoice_details sd on sd.sale_order_id =rejections.sale_order_id where plant_id=${req.plantId}`
            const data = await manager.query(query)
            if (data.length > 0) {
              return new LotDetailsResModel(true, 5555, 'So lifecylce data retrivedd', data)
            } else {
              return new LotDetailsResModel(false, 4444, 'No lifecylce data found')
            }
        } catch (err) {
            throw err;
        }
    }
    async getDetailViewById(rejectionRequest: RejectionRequest): Promise<RejectionResponseModel> {
        try {
            const manager =getManager();
            const dataQuery = `SELECT rejections.operation AS operation,si.po_number AS PoNumber,workstations.workstation as workstationName,rejection_id as rejectionId,rejections.lot_number as lotNumber,rejections.plant_id as plantId,rejections.sale_order_id as saleOrderId,rejections.rejection_quantity as rejectionQuantity,rejections.quantity as quantity ,rejections.test_id as testId ,rejections.operation as operation,rejections.workstation as workstation,rejections.shift as shift,rejections.samples as samples,rejections.rejection_reason as rejectionReason,rejections.test_result as testResult,rejections.sale_order_item_id as saleOrderItemId,qa_qc_operations.test_name as testName FROM `+ appSettings.production_db + `.rejections as rejections LEFT JOIN `+appSettings.production_db + `.qa_qc_operations qa_qc_operations ON qa_qc_operations.qa_qc_op_id = rejections.test_id LEFT JOIN `+appSettings.production_db + `.workstations workstations ON workstations.workstation_id=rejections.workstation LEFT JOIN `+appSettings.sales_db+`.so_invoice_details si ON si.sale_order_id=rejections.sale_order_id WHERE rejection_id='${rejectionRequest.rejectionId}' `
            const data = await manager.query(dataQuery)
            if (data.length > 0) {
              return new RejectionResponseModel(true, 5555, 'So lifecylce data retrivedd', data)
            } else {
              return new RejectionResponseModel(false, 4444, 'No lifecylce data found')
            }

        } catch (err) {
            throw err;
        }
    }

    async getAllRejectedLots():Promise<CommonResponse>{
        const data = await this.rejectionRepository.find({select:['lotNumber'],where:{rejectionQuantity:MoreThan(0)}})
        if(data && data.length){
            return new CommonResponse(true,1111,'Data retreived',data)
        }else{
            return new CommonResponse(false,4444,'No data found')
        }
    }
}
